// extracted by mini-css-extract-plugin
export default {"container":"TodoApp_container__JUblX"};